<template>
  <el-dialog
    :title="$t('text.assign_roles')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="400px"
    class="edit-roles"
  >
    <div>
      <el-form
        label-width="105px"
        :model="form"
        ref="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item :label="$t('text.display_name')" prop="DisplayName">
          <el-input
            v-model="form.DisplayName"
            autocomplete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('text.email') + ' / ' + $t('text.username')"
          prop="EmailAddress"
        >
          <el-input
            v-model="form.EmailAddress"
            autocomplete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.role')" prop="RoleIds">
          <el-select
            v-model="form.RoleIds"
            multiple
            filterable
            :placeholder="$t('text.select')"
            class="wp-100"
          >
            <el-option
              v-for="item in roles"
              :key="item.Id"
              :label="item.RoleName"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="submit()"
        :loading="saveLoading"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      saveLoading: false,
      form: {
        UserId: '',
        DisplayName: '',
        EmailAddress: '',
        RoleIds: []
      },
      roles: [],
      rules: this.initRules()
    }
  },
  mounted() {
    this.getRoles()
  },
  methods: {
    initRules() {
      return {
        DisplayName: [
          {
            required: true,
            message: this.$t('text.username_required'),
            trigger: 'blur'
          }
        ],
        EmailAddress: [
          {
            required: true,
            message: this.$t('text.email_is_required'),
            trigger: 'blur'
          }
        ],
        RoleIds: [
          {
            required: true,
            message: this.$t('text.please_select'),
            trigger: ['blur', 'change']
          }
        ]
      }
    },
    getRoles() {
      this.loading = true
      ApiService.GetRoles(this.$store.getters[`user/selecteOrganisationId`])
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.roles = response.data.data
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.form = {
        UserId: '',
        DisplayName: '',
        Groups: [],
        RoleIds: []
      }
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.updateUser()
        }
      })
    },
    updateUser() {
      this.saveLoading = true
      ApiService.UpdateUserRole(
        this.form.UserId,
        this.$store.getters[`user/selecteOrganisationId`],
        this.form.RoleIds
      )
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
            this.closeDialog()
            this.$parent.getData()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.saveLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
